module.exports = __webpack_public_path__ + "img/error-blue-board.b93d57f.svg";